import { render } from "./DesktopBar.vue?vue&type=template&id=4e53051e&scoped=true&ts=true"
import script from "./DesktopBar.vue?vue&type=script&lang=ts"
export * from "./DesktopBar.vue?vue&type=script&lang=ts"

import "./DesktopBar.vue?vue&type=style&index=0&id=4e53051e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e53051e"]])

export default __exports__